import getters from "@/store/modules/list/getters";
import actions from "@/store/modules/list/actions";
import mutations from "@/store/modules/list/mutations";
export default {
  namespaced: true,
  state() {
    return {
      cardGroupList: [],
      cardList: [],
      learningResult: {},
      timeStudyAvg: 0,
      isLoading: false,
      slotParentEventController: 0,
      newProCardGroupPayload: null,
      pagination: { total: 0, page: 1, limit: 10 },
      cardListPagination: { total: 0, page: 1, limit: 50 },
      learnReturnPage: 1,
    };
  },
  actions: actions,
  mutations: mutations,
  getters: getters,
};
